<script setup>
import { computed } from 'vue'
import { JHeaderLogoV2, JPertaciImage } from 'media-flow-ui'

import { formatComponentStyle } from '@/models/layout/style/component'

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  breakpoint: {
    type: String,
    required: true,
  },
})

const alt = computed(() => {
  if (props.data.props.alt) {
    return props.data.props.alt
  }
  if (props.data.props.source) {
    const sourceParts = props.data.props.source.split('/')
    return sourceParts[sourceParts.length - 1]
  }
  return ''
})

useHead({
  link: [
    {
      rel: 'preload',
      as: 'image',
      href: `${props.data.props.source}?q=80&format=webp`,
    },
  ],
})

const style = computed(() =>
  formatComponentStyle({
    ...props.data.style,
    width: null,
    height: null,
    backgroundColor: props.data.style?.backgroundColor || null,
  })
)
const imgStyle = computed(() =>
  formatComponentStyle({
    width: props.data.style?.width || { type: 'px', value: 150 },
    height: props.data.style?.height,
    objectFit: props.data.style?.objectFit,
  })
)
</script>

<template>
  <!-- {{ data.props }} -->
  <JHeaderLogoV2
    :breakpoint="breakpoint"
    :data="data"
    :logoData="data"
    :class="'order-' + data.order"
    :custom-wrapper="data.props.linkType === 1 ? 'a' : 'RouterLink'"
    :style="style"
    :url="data.props.url"
    :img-source="`${data.props.source}?q=80&format=webp`"
    :img-style="imgStyle"
  >
    <template #image-src>
      <JPertaciImage
        :imageSrc="`${data.props.source}?q=80&format=webp`"
        :alt="alt || data.props.source"
        :style="imgStyle"
      />
    </template>
  </JHeaderLogoV2>
</template>

<style></style>
